<div class="adm-shell" [class.adm-shell--drawer-open]="sidebarOpen()">
  <!-- ── Top navigation (desktop horizontal bar; collapses to a drawer on mobile) ── -->
  @if (auth.isAuthenticated$ | async) {
    <header class="adm-topnav" aria-label="Admin">
      <button
        type="button"
        class="adm-topnav__menu-btn"
        (click)="toggleSidebar()"
        aria-label="Toggle navigation menu"
        [attr.aria-expanded]="sidebarOpen()">
        <i class="bx bx-menu" aria-hidden="true"></i>
      </button>

      <a routerLink="/auth/admin-dashboard" class="adm-topnav__brand">
        <img src="./assets/logo-horizontal-dark.svg" alt="AppliedBioX" class="adm-topnav__logo" />
      </a>

      <nav class="adm-topnav__nav" aria-label="Primary">
        @for (item of primaryNav; track item.path) {
          <a
            [routerLink]="item.path"
            class="adm-topnav__link"
            [class.adm-topnav__link--active]="isNavItemActive(item)"
            [attr.aria-current]="isNavItemActive(item) ? 'page' : null">
            {{ item.label }}
          </a>
        }

        <!-- Operations cluster — collapsed into a dropdown -->
        <div class="adm-topnav__dropdown">
          <button
            type="button"
            class="adm-topnav__link adm-topnav__trigger"
            [class.adm-topnav__link--active]="isOperationsActive()"
            (click)="toggleOperations($event)"
            [attr.aria-expanded]="operationsOpen()"
            aria-haspopup="true">
            Operations
            <i class="bx bx-chevron-down adm-topnav__caret" aria-hidden="true"></i>
          </button>
          @if (operationsOpen()) {
            <div class="adm-topnav__menu" role="menu">
              @for (item of operationsNav; track item.path) {
                <a
                  [routerLink]="item.path"
                  class="adm-topnav__menu-item"
                  [class.adm-topnav__menu-item--active]="isNavItemActive(item)"
                  role="menuitem">
                  <i class="bx {{ item.icon }}" aria-hidden="true"></i>
                  <span>{{ item.label }}</span>
                </a>
              }
            </div>
          }
        </div>
      </nav>

      <div class="adm-topnav__right">
        <abx-dark-mode-toggle class="adm-topnav__theme" />
        <a
          [routerLink]="settingsNav.path"
          class="adm-topnav__settings"
          [class.adm-topnav__settings--active]="isNavItemActive(settingsNav)"
          [attr.aria-current]="isNavItemActive(settingsNav) ? 'page' : null">
          <i class="bx bx-cog" aria-hidden="true"></i>
          <span>Settings</span>
        </a>
        <span class="adm-topnav__divider" aria-hidden="true"></span>
        <bodyanalytics-profile-menu [accountUrl]="profileAccountUrl" />
      </div>
    </header>
  }

  <!-- ── Mobile off-canvas drawer (full grouped nav) ── -->
  @if (auth.isAuthenticated$ | async) {
    <aside class="adm-drawer" aria-label="Admin navigation">
      <div class="adm-drawer__brand">
        <img src="./assets/logo-horizontal-dark.svg" alt="AppliedBioX" class="adm-drawer__logo" />
        <div class="eyebrow adm-drawer__portal-label">Admin console</div>
      </div>
      <nav class="adm-drawer__nav" aria-label="Admin">
        @for (group of navGroups; track $index) {
          <div class="adm-drawer__group">
            @if (group.header) {
              <div class="eyebrow adm-drawer__group-header">{{ group.header }}</div>
            }
            @for (item of group.items; track item.path) {
              <a
                [routerLink]="item.path"
                class="adm-drawer__item"
                [class.adm-drawer__item--active]="isNavItemActive(item)"
                [attr.aria-current]="isNavItemActive(item) ? 'page' : null">
                <i class="bx {{ item.icon }} adm-drawer__icon"></i>
                <span>{{ item.label }}</span>
              </a>
            }
          </div>
        }
      </nav>
      <div class="adm-drawer__user">
        <bodyanalytics-profile-menu [accountUrl]="profileAccountUrl" />
      </div>
    </aside>
  }
  @if (sidebarOpen()) {
    <div class="adm-drawer__backdrop" (click)="closeSidebar()" aria-hidden="true"></div>
  }

  <!-- ── Page-header band (data-driven title; preserved from the old topbar) ──
       Hidden on routes whose leaf component renders its own `.adm-page__header`
       (see AdminShellComponent.hideHeaderBand) so the two headers don't stack. -->
  @if ((auth.isAuthenticated$ | async) && !hideHeaderBand()) {
    <div class="adm-pagehead">
      <div class="eyebrow adm-pagehead__subtitle">{{ pageSubtitle }}</div>
      <h1 class="adm-pagehead__title">{{ pageTitle }}</h1>
    </div>
  }

  <!-- ── Page content ── -->
  <div class="adm-content">
    <router-outlet />
    <!-- #2246: the full marketing footer (nav columns, social, CTAs) belongs on
         public pages, not inside the signed-in admin shell — replaced with a
         slim internal footer. -->
    <footer class="adm-footer">
      <span>© {{ currentYear }} AppliedBioX</span>
      <a href="mailto:support@appliedbiox.com">Support</a>
    </footer>
  </div>

  <!-- Mobile bottom tab bar (CSS-gated to <=767px) -->
  @if (auth.isAuthenticated$ | async) {
    <bodyanalytics-mobile-tab-bar class="adm-shell__tabbar" [tabs]="mobileTabs" [activeRoute]="currentUrl" />
  }
</div>
